import React from 'react';
import PropTypes from 'prop-types';
import styles from './PaymentsDetails.module.scss';

const AllPaymentsHistory = ({ data, pageId, handleViewMorePayments, showMorePayments }) => {
  const statusColorObj = {
    0: styles.Pending,
    1: styles.Sucess,
    2: styles.Inprogress,
    3: styles.Cancel,
  };

  // const handleClickViewPaymentHistory = async () => {
  //   await clickTracker('payments_details_viewhistory', 'payments_details');
  //   handleRedirection(source, paymentHistoryUrl || '');
  // };

  return (
    <>
      <div className="p-20">
        {/* Heading */}
        <div className={`${styles.Heading}`}>
          <div className={`${styles.Title} font16 fw700 color111`}>Payment Confirmation</div>
        </div>
        {/* Heading */}

        {/* Status Box */}

        {data &&
          data.map((eachObj, idx) => (
            <div className={`${styles.StatusBox} mt-10`} key={idx}>
              <div className={`${styles.StatusBoxInner}`}>
                <div className={`${styles.StatusTopBar}`}>
                  {eachObj?.amountDetails &&
                    eachObj?.amountDetails.map((item, i) => (
                      <div className={`${styles.StatusColumn}`} key={i}>
                        <div className={`${styles.Status__Lable} font12 fw500 color777`}>{item?.label}</div>
                        <div
                          id={item?.label === 'Amount' && 'paymentAmountSymbol'}
                          className={`${
                            item?.label === 'Mode' ? styles.Status__Mode__LabelText : styles.Status__LabelText
                          } font14 fw600 color111 mt-2`}
                        >
                          {item?.value}
                        </div>
                      </div>
                    ))}
                </div>

                <ul className={`${styles.Timeline__List} mt-10`}>
                  {eachObj?.status &&
                    eachObj?.status.map((item, i) => (
                      <li className={`${styles.Timeline__Item} ${statusColorObj[item?.flag]}`} key={i}>
                        <div className={`${styles.Timeline__Circle} csicon `} />
                        <div className={`${styles.Timeline__Text} mt-10`}>
                          <div className={`${styles.Timeline__Status} font13 fw500`}>{item?.label}</div>
                          <div className={`${styles.Timeline__Date} font11 fw400 color777`}>{item?.date}</div>
                        </div>
                      </li>
                    ))}
                </ul>
                {eachObj?.reason && <div className={`${styles.StatusError} font11 fw400 mt-15`}>{eachObj?.reason}</div>}
              </div>
              {pageId === 'home' && showMorePayments && (
                <div className={`${styles.StatusBox}`}>
                  <button
                    type="button"
                    onClick={() => handleViewMorePayments()}
                    className={`${styles.StatusButton} ${styles.whitefill_animate} font12 fw600 color007`}
                  >
                    View More Payments
                  </button>
                </div>
              )}
            </div>
          ))}
      </div>
    </>
  );
};

AllPaymentsHistory.propTypes = {
  data: PropTypes.array,
  pageId: PropTypes.string,
  handleViewMorePayments: PropTypes.func,
  showMorePayments: PropTypes.bool,
};

AllPaymentsHistory.defaultProps = {
  pageId: '',
  showMorePayments: false,
};

export default AllPaymentsHistory;
